<a class="wrapper" (click)="goBack()">
  <i class="icon-arrow-l arrow"></i>
  <p class="caption">{{caption}}</p>
</a>

